import {useQueryParamsCallback} from '@aboutyou/router';
import {QUICK_VIEW_USPS_AND_BEST_PRICE_GUARANTEE_QUERY_PARAM} from '../QuickViewUSPs/QuickViewUSPsView';

export const useShouldShowBestPriceGuarantee = () => {
  const queryParamsCallback = useQueryParamsCallback();
  return (
    queryParamsCallback().get(
      QUICK_VIEW_USPS_AND_BEST_PRICE_GUARANTEE_QUERY_PARAM,
    ) === '5'
  );
};
